import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import SEO from "../components/SEO";
import SocialAuthButtons from "../components/SocialAuthButtons";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(`Bem-vindo, ${u.name}!`);
      navigate(next && next.startsWith("/") && !next.startsWith("//") ? next : "/feed");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao entrar");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <SEO title="Entrar" path="/login" noindex />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary flex items-center justify-center mb-3">
            <Sparkles className="w-7 h-7 text-primary-foreground" />
          </div>
          <h1 className="font-heading font-bold text-2xl">Entrar</h1>
          <p className="text-sm text-muted-foreground">Guia de Jampa AI</p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail" className="w-full h-12 px-4 rounded-2xl bg-card border border-border focus:ring-2 focus:ring-primary outline-none" />
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha" className="w-full h-12 px-4 rounded-2xl bg-card border border-border focus:ring-2 focus:ring-primary outline-none" />
          {error && <p data-testid="login-error" className="text-sm text-alert">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full h-12 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center disabled:opacity-60 active:scale-95 transition-transform">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Entrar"}
          </button>
        </form>

        <div className="flex items-center gap-3 my-6">
          <div className="h-px flex-1 bg-border" />
          <span className="text-xs text-muted-foreground uppercase tracking-wider">ou continue com</span>
          <div className="h-px flex-1 bg-border" />
        </div>
        <SocialAuthButtons />
        <p className="text-center text-sm text-muted-foreground mt-5">
          Não tem conta? <Link data-testid="login-to-register" to="/cadastro" className="text-primary font-semibold">Cadastre-se</Link>
        </p>
        <p className="text-center text-sm text-muted-foreground mt-2">
          <Link data-testid="login-to-forgot" to="/esqueci-senha" className="text-primary font-semibold">Esqueci minha senha</Link>
        </p>
      </motion.div>
    </div>
  );
}
